import React from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'apps/promo/components/common/ColoredSectionContainer';
import { PromoPageContainer } from 'apps/promo/components/common/promo-page-container/PromoPageContainer';
import { CardsSection } from 'apps/promo/components/common/sections/CardsSection';
import FaqSection from 'apps/promo/components/common/sections/FaqSection';
import HeadingSection from 'apps/promo/components/common/sections/HeadingSection';
import { HeroSection } from 'apps/promo/components/common/sections/HeroSection';
import { HighlightedTilesSection } from 'apps/promo/components/common/sections/highlighted-tiles-section/HighlightedTilesSection';
import { TilesSection } from 'apps/promo/components/common/sections/TilesSection';
import NotAuthBasePage from 'apps/promo/components/NotAuthBasePage';
import { TransferAccordion } from 'apps/promo/components/visa-page/TransferAccordion';
import { TransferTable } from 'apps/promo/components/visa-page/TransferTable';
import { useMatchMedia } from 'apps/promo/hooks/useMatchMedia';
import promoBreakpoints from 'apps/promo/theme/promoBreakpoints';

const VisaPage = (props) => {
    const isDesktop = useMatchMedia(promoBreakpoints.desktop1440);

    return (
        <PromoPageContainer bgColor="white" noIndent>
            {props.heroTitle && <HeroSection title={props.heroTitle} text={props.heroText} img={props.heroImg} data={props.heroData} />}
            <ColoredSectionContainer noTopPadding bgColor="eggshell03">
                {(props.headline1Title || props.headline1Text) && <HeadingSection title={props.headline1Title} text={props.headline1Text} />}
                {props.tiles1 && <TilesSection data={props.tiles1} lang={props.lang} country={props.country} grayText />}

                {(props.headline2Title || props.headline2Text) && <HeadingSection title={props.headline2Title} text={props.headline2Text} noTopIndent />}
                {props.tiles2 && <TilesSection data={props.tiles2} lang={props.lang} country={props.country} grayText />}

                {(props.headline6Title || props.headline6Text) && <HeadingSection title={props.headline6Title} text={props.headline6Text} />}
                {props.tiles3 && <TilesSection data={props.tiles3} lang={props.lang} country={props.country} grayText />}

                {(props.headline3Title || props.headline3Text) && <HeadingSection title={props.headline3Title} text={props.headline3Text} />}
                {props.highlightedTiles1 && <HighlightedTilesSection data={props.highlightedTiles1} />}

                {(props.headline4Title || props.headline4Text) && <HeadingSection title={props.headline4Title} text={props.headline4Text} />}

                {props.transferMethods &&
                    (isDesktop ? <TransferTable transferMethods={props.transferMethods} /> : <TransferAccordion transferMethods={props.transferMethods} />)}

                {(props.headline5Title || props.headline5Text) && <HeadingSection title={props.headline5Title} text={props.headline5Text} />}
                {props.highlightedTiles2 && <HighlightedTilesSection data={props.highlightedTiles2} />}

                {(props.headline7Title || props.headline7Text) && <HeadingSection title={props.headline7Title} text={props.headline7Text} />}

                {props.highlightedTilesWide && <CardsSection data={props.highlightedTilesWide} variant="halfWidth" />}

                {(props.headline8Title || props.headline8Text) && <HeadingSection title={props.headline8Title} text={props.headline8Text} />}
                {props.highlightedTiles4 && <HighlightedTilesSection data={props.highlightedTiles4} />}
            </ColoredSectionContainer>

            {props.faqTitle && props.questions && <FaqSection title={props.faqTitle} questions={props.questions} noTopPadding />}
        </PromoPageContainer>
    );
};

const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroText: state.extra?.strapiApi?.hero_block?.text,
        heroData: state.extra?.strapiApi?.hero_block,
        heroImg: state.extra?.strapiApi?.hero_block?.img,

        headline1Title: state.extra?.strapiApi?.headline1?.title,
        headline1Text: state.extra?.strapiApi?.headline1?.text,

        tiles1: state.extra?.strapiApi?.tiles_section,

        headline2Title: state.extra?.strapiApi?.headline2?.title,
        headline2Text: state.extra?.strapiApi?.headline2?.text,

        tiles2: state.extra?.strapiApi?.tiles_section2,

        headline3Title: state.extra?.strapiApi?.headline3?.title,
        headline3Text: state.extra?.strapiApi?.headline3?.text,

        highlightedTiles1: state.extra?.strapiApi?.tiles_highlighted,

        headline4Title: state.extra?.strapiApi?.headline4?.title,
        headline4Text: state.extra?.strapiApi?.headline4?.text,

        transferMethods: state.extra?.strapiApi?.transfer_methods,

        headline5Title: state.extra?.strapiApi?.headline5?.title,
        headline5Text: state.extra?.strapiApi?.headline5?.text,

        highlightedTiles2: state.extra?.strapiApi?.tiles_highlighted2,

        headline6Title: state.extra?.strapiApi?.headline6?.title,
        headline6Text: state.extra?.strapiApi?.headline6?.text,

        headline7Title: state.extra?.strapiApi?.headline7?.title,
        headline7Text: state.extra?.strapiApi?.headline7?.text,

        tiles3: state.extra?.strapiApi?.tiles_section3,

        highlightedTilesWide: state.extra?.strapiApi?.tiles_highlighted3,

        headline8Title: state.extra?.strapiApi?.headline8?.title,
        headline8Text: state.extra?.strapiApi?.headline8?.text,

        highlightedTiles4: state.extra?.strapiApi?.tiles_highlighted4,

        faqTitle: state.extra?.strapiApi?.faq?.title,
        questions: state.extra?.strapiApi?.faq?.questions,

        lang: state.extra?.noAuthFooter?.language?.lang,
        country: state.extra?.noAuthFooter?.language?.country,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(VisaPage));
